import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import ActionType from '../../actions/ActionType'
import { createGroup } from '../../actions/contacts/groups'
import language from 'utils/vast-languagepack'

const mapStateToProps = (state) => ({
  modalOpen: state.contacts.createGroupFromSelectedDialogOpen,
  modalFieldValue: state.contacts.createGroupFromSelectedFieldValue,
  selectedContacts: state.contacts.selectedContacts,
})

const mapDispatchToProps = (dispatch) => {
  const { Contacts } = ActionType
  const dispatchType = (type, payload) => (dispatch) =>
    dispatch({ type, payload })
  return bindActionCreators(
    {
      closeDialog: () =>
        dispatchType(Contacts.CLOSE_CREATE_GROUP_FROM_SELECTED_DIALOG),
      handleFieldChange: (value) =>
        dispatchType(
          Contacts.HANDLE_CREATE_GROUP_FROM_SELECTED_FIELD_CHANGE,
          value,
        ),
      createGroupFromSelected: (title, contacts) =>
        dispatchType(Contacts.CREATE_GROUP_FROM_SELECTED, { title, contacts }),
      createGroup,
    },
    dispatch,
  )
}

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  dialogContentStyles: {
    padding: '25px',
  },
})

class CreateOrUpdateGroupDialog extends Component {
  handleDialogClose = () => {
    this.props.closeDialog()
  }

  handleChange = () => (event) => {
    this.props.handleFieldChange(event.target.value)
  }

  handleDialogCloseSave = () => {
    // this.props.createGroupFromSelected(this.props.modalFieldValue, this.props.selectedContacts)
    this.props.createGroup(
      this.props.modalFieldValue,
      Object.keys(this.props.selectedContacts),
    )
  }

  render() {
    const { modalFieldValue, classes } = this.props

    return (
      <Dialog open={this.props.modalOpen} onClose={this.handleDialogClose}>
        <div className={classes.dialogContentStyles}>
          <DialogTitle>{language.contacts.add.createGroups}</DialogTitle>
          <TextField
            onChange={this.handleChange()}
            label={language.contacts.add.labels.groupTitle}
            fullWidth
            value={modalFieldValue}
          />
          <Button
            onClick={this.handleDialogClose}
            color="secondary"
            className={classes.button}
          >
            {language.contacts.add.cancel}
          </Button>
          <Button
            onClick={this.handleDialogCloseSave}
            color="secondary"
            className={classes.button}
          >
            {language.contacts.add.ok}
          </Button>
        </div>
      </Dialog>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(CreateOrUpdateGroupDialog))
